import { Stack, Text, Pill, InputLabel } from '@/theme/components';
import { styled } from '@/theme/index';

export const TextWithMax3Lines = styled(Text)(() => ({
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
}));

export const CollapsedTextContainer = styled('div')(() => ({
  height: '116px',
  width: '100%',
}));

export const LogoTagContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));

export const RewardTypePill = styled(Pill)(({ theme }) => ({
  borderRadius: '4px',
  height: '22px',
  backgroundColor: theme.palette.secondary.main,
}));

export const HeroImage = styled('div')(({ theme }) => ({
  height: '197px',
  width: '100%',
  '@media screen and (min-width: 768px)': {
    position: 'absolute',
    width: '264px',
    right: '20px',
    top: '36.5%',
    margin: 0,
  },
  [theme.breakpoints.up('lg')]: {
    width: '394px',
  },
}));

export const CollapsedContentStackContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-end',
  backgroundColor: theme.palette.customCard?.light || 'initial',
  border: `2px solid ${theme.palette.secondary.light}`,
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '16px',
  width: 'calc(100vw - 30px)',
  flex: 'none',
  order: 1,
  alignSelf: 'stretch',
  flexGrow: 0,
  cursor: 'pointer',
  [theme.breakpoints.up('sm')]: {
    width: '288px ',
  },
  '&:hover': {
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: `0px 2px 4px ${theme.palette.primary.main}`,
  },
}));

export const ExpandedLeftTextContainer = styled(Stack)(() => ({
  '@media screen and (min-width: 768px)': {
    maxWidth: '56%',
  },
}));

export const ExpandedRelativeContainer = styled('div')(() => ({
  textAlign: 'left',
  position: 'relative',
}));

export const StyledInputLabel = styled(InputLabel)(() => ({
  color: 'black',
  fontWeight: 'bold',
}));
